import { FC, useState } from 'react';
import classNames from 'classnames';
import { Icon } from 'common-components';
import styles from './accordion.module.scss';
import { AccordionProps } from './accordionTypes';
import useResizeObserver from '../useResizeObserver';

const Accordion: FC<AccordionProps> = (props: AccordionProps) => {
    const { title, children, info, width = 20, adornment, initIsExpanded = false } = props;
    const TITLE_HEIGHT_PX = 40;

    const [isExpanded, setIsExpanded] = useState<boolean>(initIsExpanded);

    const { height: childrenHeight, resizedContainerRef } = useResizeObserver();

    const getContainerHeight = () => {
        const expandedHeightPX = childrenHeight + TITLE_HEIGHT_PX;
        return isExpanded ? `${expandedHeightPX}px` : '3rem';
    };

    const onChildrenClick = (e: any) => {
        e.stopPropagation();
    };

    return (
        <div
            data-testid="accordion"
            className={classNames(styles['accordion-container'], isExpanded && styles['expanded-accordion-container'])}
            style={{ height: getContainerHeight(), width: `${width}rem` }}
            onClick={() => setIsExpanded(!isExpanded)}
        >
            <div className={styles['title-container']}>
                <div className={styles['title-container-left']}>
                    <span className={styles.title}>{title}</span>
                    {info && <span className={styles.info}>{info}</span>}
                    {adornment && <span className={styles.adornment}>{adornment}</span>}
                </div>
                <Icon
                    dataTestid="expand"
                    name={'downArrowIcon'}
                    className={styles.icon}
                    style={{ transform: isExpanded ? 'rotate(180deg' : '' }}
                />
            </div>
            <div
                ref={resizedContainerRef}
                className={classNames(styles['children-container'], !isExpanded && styles['hidden-children'])}
                onClick={onChildrenClick}
            >
                {children}
            </div>
        </div>
    );
};

export default Accordion;
